import React from 'react';
import {
  FlexRow,
  IconButton,
  FlexSpacer,
  Dropdown,
  DropdownMenuButton,
  Panel,
} from '@epam/promo';
import { ReactComponent as navigationMoreIcon } from '@epam/assets/icons/common/navigation-more_horiz-18.svg';
import { ReactComponent as DeleteIcon } from '@epam/assets/icons/common/action-delete-12.svg';

import { useDropdown } from 'hooks';
import { useUserRole } from 'hooks/helpers';
import { StatusIndicator, Tag } from 'components/common';
import { CardProps } from './Card.model';
import css from './Card.module.scss';
import { FormattedDate } from '../../common/FormattedDate';
import { HighlightedTitle } from '../../common/HighlightedTitle';
import { CardDescription } from '../../common/CardDescription';

export const Card = ({ item, isActive, onClick, onDelete }: CardProps) => {
  const { openDropdownMenu } = useDropdown();
  const { isSuperAdmin } = useUserRole();

  return (
    <div
      aria-hidden="true"
      className={isActive ? css['card__active-container'] : css.card__inactive}
      role="button"
      tabIndex={0}
      onClick={onClick}>
      <li className={isActive ? `${css.card} ${css.card__active}` : css.card}>
        <FlexRow size={null}>
          <Tag value={item.completedTasks} />
          <FlexSpacer />
          {isSuperAdmin && (
            <Dropdown
              placement="bottom-end"
              renderBody={() => (
                <Panel shadow background="white">
                  <DropdownMenuButton
                    caption="Delete"
                    cx={css['dropdown-button']}
                    icon={DeleteIcon}
                    onClick={(event: React.MouseEvent<HTMLElement>) => {
                      event.stopPropagation();
                      const target = event.target as HTMLInputElement;

                      onDelete(target.value);
                    }}
                  />
                </Panel>
              )}
              renderTarget={({ ref, onClick: handleMenuItemClick }) => (
                <IconButton
                  ref={ref}
                  icon={navigationMoreIcon}
                  onClick={(event: React.MouseEvent<HTMLElement>) =>
                    openDropdownMenu(event, handleMenuItemClick)
                  }
                />
              )}
            />
          )}
        </FlexRow>

        <HighlightedTitle title={item.title} />

        <CardDescription description={item.description} />

        <FlexRow cx={css.card__details} size={null}>
          <StatusIndicator size="8" status={item.status} />
          <FlexSpacer />
          <FormattedDate date={item.updatedAt} />
        </FlexRow>
      </li>
    </div>
  );
};
